import Http from '../../../libs/Http';

export const notifyNewTrades = async ()=>{
  const trades = await Http.get('/admin/activeTradeIds');

  const seenTrades = JSON.parse(localStorage.getItem('seenTrades') || '{}');

  let newTrades = false;
  const newSeenTrades = {};
  trades.forEach(trade=>{
    newSeenTrades[trade.tradeId] = true;
    if(!seenTrades[trade.tradeId]){
      newTrades = true;
    }
  });
  localStorage.setItem('seenTrades', JSON.stringify(newSeenTrades));
  if(newTrades){
    const audio = new Audio('/audio/ping.mp3');
    audio.play();
  }
};

export const updateSavedViewDate = (trades) => {
  const viewedData = JSON.parse(localStorage.getItem('viewedData') || '{}');
  const newViewedData = {};
  trades.forEach(trade=>{
    newViewedData[trade.tradeId] = viewedData[trade.tradeId];
  });
  localStorage.setItem('viewedData', JSON.stringify(newViewedData));

};

export const getSavedViewData = (tradeId)=>{
  const viewedData = JSON.parse(localStorage.getItem('viewedData') || '{}');
  return viewedData[tradeId] || {
    receivedMessagesCount: 0,
    photosCount: 0,
    paymentsCount: 0,
  };
};

export const saveViewedData = (trade)=>{
  const viewedData = JSON.parse(localStorage.getItem('viewedData') || '{}');
  const data = {
    receivedMessagesCount: trade.receivedMessagesCount,
    photosCount: trade.photosCount,
    paymentsCount: trade.paymentsCount,
  };

  viewedData[trade.tradeId] = data;

  localStorage.setItem('viewedData', JSON.stringify(viewedData));
};



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/Trades.helper.js